import type { GameAction, InputFrame, Vec2 } from "./types.js";

/** JSON-safe input frame for WebSocket transport. */
export interface WireInputFrame {
  move: Vec2;
  held: GameAction[];
  pressed: GameAction[];
  kickPower?: number;
  kickKind?: "pass" | "shoot" | "cross";
  shotStyle?: InputFrame["shotStyle"];
}

export const NEUTRAL_WIRE_INPUT: WireInputFrame = {
  move: { x: 0, y: 0 },
  held: [],
  pressed: [],
};

export function encodeInputFrame(frame: InputFrame): WireInputFrame {
  return {
    move: { x: frame.move.x, y: frame.move.y },
    held: [...frame.held],
    pressed: [...frame.pressed],
    kickPower: frame.kickPower,
    kickKind: frame.kickKind,
    shotStyle: frame.shotStyle,
  };
}

export function decodeInputFrame(wire: WireInputFrame): InputFrame {
  return {
    move: { x: wire.move.x, y: wire.move.y },
    held: new Set(wire.held),
    pressed: new Set(wire.pressed),
    kickPower: wire.kickPower,
    kickKind: wire.kickKind,
    shotStyle: wire.shotStyle,
  };
}
